import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import styles from "./BranchCarousel.module.css";
import {
  EffectFade,
  EffectCube,
  EffectCoverflow,
  EffectFlip,
  Autoplay,
} from "swiper/modules";

// Import the modules from Swiper
import { Navigation, Pagination } from "swiper/modules";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import { useNavigate } from "react-router-dom";


export const repeatObjects = (arr=[],number=4) => {
  if (arr?.length >= number) return arr; // If already 4 or more, return as is

  let repeatedArr = [...arr]; // Clone the original array

  while (repeatedArr.length < number) {
    repeatedArr = [...repeatedArr, ...arr]; // Repeat the original array
  }

  return repeatedArr.slice(0, Math.max(number, arr.length * 2)); // Ensure correct length
}


const BranchCarousel = ({ data }) => {
  const swiperRef = useRef(null);
  const [centerSlideIndex, setCenterSlideIndex] = useState(1);
  const width = useDeviceWidth();
  const navigate = useNavigate();
  console.log('branch data is', data?.listingItems)

  const handleSlideChange = (swiper) => {
    const activeIndex = swiper.activeIndex;
    const slidesPerView = 3; // 3 slides shown at once
    const totalSlides = data?.listingItems.length;

    // Find the center index
    let centerIndex = activeIndex;

    if (slidesPerView === 3) {
      // If there are 3 slides shown at once, center slide is the middle slide
      if (activeIndex > 0 && activeIndex < totalSlides - 1) {
        centerIndex = activeIndex + 1; // Center index is one slide after the activeIndex
      } else if (activeIndex === totalSlides - 1) {
        centerIndex = activeIndex - 1; // If it's the last slide, the second to last is the center
      }
    }

    setCenterSlideIndex(centerIndex);
  };

  console.log("center slide", centerSlideIndex);

  return (
    <div className={`${styles.outer} primary-500`}>
      <img className={styles.branchImage} src="/img/branch-map.svg" alt="Map" />
      <div className={styles.locations} data-aos="fade-down" data-aos-delay="150">
        <p className={`${styles.subTitle} bg-primary-200 primary-500`}>
          {data?.subTitle}
        </p>
        {data?.showTitle && (
          <h1
            className="primary-100"
            dangerouslySetInnerHTML={{ __html: data?.title }}
          ></h1>
        )}
        {/* <h2 className="primary-100">Excellence</h2> */}
        {/* <div className={`${styles.underLine} bg-primary-100`} /> */}
      </div>
      <div className={styles.sliderOuter}>
        <img
          src="/img/left-arrow.svg"
          alt="Prev"
          className={styles.leftArrow}
          onClick={() => swiperRef.current?.slidePrev()} // Trigger previous slide
        />
        <img
          src="/img/left-arrow.svg"
          alt="Next"
          className={styles.rightArrow}
          onClick={() => swiperRef.current?.slideNext()} // Trigger next slide
        />
        <div className={styles.swiperOuter}>
          {/* Custom Navigation Arrows */}

          {/* Swiper */}
          <Swiper
            // modules={[Navigation, Pagination]} // Enable navigation and pagination
            slidesPerView={width > 768 ? 1 : 1} // Show 3 images at a time
            spaceBetween={20} // Add space between slides
            centeredSlides={true}
            modules={[Autoplay]}
            autoplay={{
              delay: 4000, // 3 seconds
              disableOnInteraction: false, // Autoplay continues even after interaction
            }}
            // effect = "flip"
            // modules={[Pagination]}
            onSlideChange={handleSlideChange}
            onSwiper={(swiper) => (swiperRef.current = swiper)} // Attach the Swiper instance to the ref
            pagination={{ clickable: true }} // Enable clickable dots
            loop={true} // Enable infinite looping
            draggable={true} // Enable drag/swipe functionality
            className="branchSwiper"
          >
            {repeatObjects(data?.listingItems)?.map((slide, index) => (
              <SwiperSlide key={index}>
                <div className={`${styles.cardOuter} branch-outer`}>
                  <img
                    src={
                      slide?.images?.find((item) => item?.mainImage == "yes")
                        ?.url
                    }
                    alt={
                      slide?.images?.find((item) => item?.mainImage == "yes")
                        ?.imageTag
                    }
                    className={`${styles.singleImage} branch-image`}
                  />
                  <div className={styles.branchDet}>
                  <div className={styles.locationDiv}>
                    <img src="/img/branch-location.svg" alt="location" />
                    <p>{slide.location}</p>
                  </div>
                  <h2>{slide.name}</h2>
                  <h5 dangerouslySetInnerHTML={{ __html: slide?.description }}></h5>
                  <div className={styles.contactDiv}>
                    <img src="/img/branch-contact.svg" alt="contact" />
                    <p>{slide?.phoneNumber}</p>
                  </div>
                  <button
                    className={`${styles.explore} primary-300`}
                    onClick={() => navigate(`/branch/${slide?.slug}`)}
                  >
                    Explore
                  </button>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      {width <= 768 && (
        <div className={styles.mobileArrows}>
          <img
            src="/img/left-arrow.svg"
            alt="Prev"
            className={styles.lArrow}
            onClick={() => swiperRef.current?.slidePrev()} // Trigger previous slide
          />
          <img
            src="/img/left-arrow.svg"
            alt="Next"
            className={styles.rArrow}
            onClick={() => swiperRef.current?.slideNext()} // Trigger next slide
          />
        </div>
      )}
    </div>
  );
};

export default BranchCarousel;
